/** LE LIEN — la carte qui met le lien de réservation sous le nez du pro.
 *  C'est le geste le plus rentable de l'application : sans lien partagé, rien ne rentre.
 *  Elle vit sur la journée et sur les clientes, là où le pro passe ses journées. */
import React from "react";
import { toast } from "sonner";
import { Copy, ExternalLink, Share2 } from "lucide-react";
import { useApp } from "../App";

export function CarteLien({ compact = false }) {
  const { compte } = useApp();
  if (!compte?.slug) return null;
  const lien = `${window.location.origin}/r/${compte.slug}`;
  const court = lien.replace(/^https?:\/\//, "");

  const copier = () =>
    navigator.clipboard
      .writeText(lien)
      .then(() => toast.success("Lien copié. Colle-le dans ta bio Instagram."))
      .catch(() => toast.error("Copie impossible sur ce navigateur."));

  const partager = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: compte.activite || "Réserve en ligne",
          text: "Réserve ton rendez-vous ici :",
          url: lien,
        });
        return;
      } catch {
        /* l'utilisateur a fermé le partage */
      }
    }
    copier();
  };

  return (
    <div
      data-testid="carte-lien-reservation"
      className={compact ? "p-3.5" : "p-4"}
      style={{
        background: "var(--accent-soft)",
        border: "1px solid var(--accent)",
        borderRadius: "var(--radius-lg)",
      }}
    >
      <div className="flex flex-wrap items-center gap-x-4 gap-y-3">
        <div className="min-w-0 flex-1">
          <p className="micro" style={{ color: "var(--accent)" }}>
            Ton lien de réservation
          </p>
          <p className="text-[14.5px] font-semibold truncate" data-testid="carte-lien-url">
            {court}
          </p>
          {!compact && (
            <p className="text-[12.5px] mt-0.5" style={{ color: "var(--text-muted)" }}>
              Mets-le dans ta bio Instagram et envoie-le à tes clientes : elles réservent
              seules, tes places sont à jour en direct.
            </p>
          )}
        </div>
        <div className="flex gap-1.5 shrink-0">
          <Bouton icone={Copy} libelle="Copier" onClick={copier} testid="carte-lien-copier" />
          <Bouton icone={Share2} libelle="Partager" onClick={partager} testid="carte-lien-partager" />
          <Bouton
            icone={ExternalLink}
            libelle="Voir"
            onClick={() => window.open(lien, "_blank")}
            testid="carte-lien-voir"
          />
        </div>
      </div>
    </div>
  );
}

function Bouton({ icone: Icone, libelle, onClick, testid }) {
  return (
    <button
      onClick={onClick}
      title={libelle}
      aria-label={libelle}
      data-testid={testid}
      className="inline-flex h-10 items-center gap-1.5 px-3 text-[13px] font-semibold cible-tactile"
      style={{
        background: "var(--surface)",
        border: "1px solid var(--border)",
        borderRadius: "var(--radius-full)",
        color: "var(--text)",
      }}
    >
      <Icone size={15} strokeWidth={1.9} />
      <span className="hidden sm:inline">{libelle}</span>
    </button>
  );
}
